import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { esTipoTope } from './regla-utils';
import SgxDateInput from '../components/sgxDateInput';

const redirect = (basePath, id, data) => {
  if (esTipoTope(data.idTipoRegla)) {
    return `/tope/${id}`;
  }
  return `${basePath}/${id}/show`;
};

const ReglaCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect={redirect}>
      <TextInput source="descripcion" validate={[required()]} />
      <TextInput source="descripcionCompleta" validate={[required()]} />
      <ReferenceInput
        source="idCodigoRechazo"
        reference="codigo-rechazo"
        filter={{ deleted: false }}
      >
        <SelectInput optionText="descripcion" optionValue="id" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput
        source="idGrupoRegla"
        reference="grupo-regla"
        filter={{ deleted: false }}
      >
        <SelectInput optionText="descripcion" optionValue="id" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput
        source="idTipoRegla"
        reference="tipos-regla"
      >
        <SelectInput optionText="descripcion" optionValue="id" validate={[required()]} />
      </ReferenceInput>

      <SgxDateInput source="desde" label="resources.regla.fields.desde" validate={[required('Requerido')]} />
      <SgxDateInput source="hasta" label="resources.regla.fields.hasta" validate={[required('Requerido')]} defaultValue={new Date(9999, 11, 31)}/>
    </SimpleForm>
  </Create>
);

export default ReglaCreate;
